import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";

import "./index.css";

import App from "./App";
import { supabase } from "./lib/supabase";
import { useAuthStore } from "./store/authStore";

// Kick off auth initialization. authStore reads/writes through the SupabaseClient
// we pass in here.
void useAuthStore.getState().initialize(supabase);

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
